module.exports = __webpack_public_path__ + "static/media/picture3.89c4baa3.jpg";